'use strict';exports.__esModule = true;var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _OMAccordion = require('./OMAccordion.scss');var _OMAccordion2 = _interopRequireDefault(_OMAccordion);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

OMAccordion = function (_Component) {_inherits(OMAccordion, _Component);function OMAccordion() {var _temp, _this, _ret;_classCallCheck(this, OMAccordion);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      accordionOpen: _this.props.accordionOpen,
      height: 0 }, _this.






















    onChange = function () {
      var accordionOpen = !_this.state.accordionOpen;
      var contentEl = _this.accordionSectionContent;
      var height = void 0;
      if (accordionOpen) {
        var marginTop = contentEl && contentEl.firstChild && window.getComputedStyle(contentEl.firstChild).marginTop;
        marginTop = parseInt(marginTop, 10) || 0;
        height = (contentEl && contentEl.scrollHeight || 0) + marginTop;
        if (_this.props.onOpen) {_this.props.onOpen();}
      } else if (_this.props.onClose) {
        _this.props.onClose();
      }

      height = height || _this.state.height;

      _this.setState({
        accordionOpen: accordionOpen,
        height: height });

    }, _temp), _possibleConstructorReturn(_this, _ret);}OMAccordion.prototype.componentDidMount = function componentDidMount() {var _this2 = this;setTimeout(function () {if (_this2.props.accordionOpen) {var contentEl = _this2.accordionSectionContent;var marginTop = contentEl && contentEl.firstChild && window.getComputedStyle(contentEl.firstChild).marginTop;marginTop = parseInt(marginTop, 10) || 0; // Any suggestion how to improve it?
        _this2.setState({ height: (contentEl && contentEl.scrollHeight || 0) + marginTop }, function () {return _this2.props.afterInitialOpen && _this2.props.afterInitialOpen();});}}, 300);};OMAccordion.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {var accordionOpen = _ref.accordionOpen;if (this.props.accordionOpen !== accordionOpen) {this.setState({ accordionOpen: accordionOpen });}};OMAccordion.prototype.
  render = function render() {var _cx,_this3 = this;
    var style = this.state.accordionOpen && this.state.height ? { height: this.state.height + 'px' } : {};

    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(_OMAccordion2.default.accordion, this.props.className) },
        _react2.default.createElement('div', { className: _OMAccordion2.default.accordionSection },
          _react2.default.createElement('div', { onClick: this.onChange, className: (0, _classnames2.default)(_OMAccordion2.default.accordionHeader, 'accordion-header') },
            _react2.default.createElement('span', { className: (0, _classnames2.default)(_OMAccordion2.default.accordionSectionTitle, 'accordion-title') }, this.props.titleValue),
            _react2.default.createElement('span', {
              className: (0, _classnames2.default)('icon', {
                'icon-arrow-up': this.state.accordionOpen,
                'icon-arrow-down': !this.state.accordionOpen }) })),



          _react2.default.createElement('div', {
              className: (0, _classnames2.default)(_OMAccordion2.default.accordionSectionContent, 'accordion-content', (_cx = {}, _cx[_OMAccordion2.default.open] = this.state.accordionOpen, _cx)),
              style: style,
              ref: function ref(_ref2) {_this3.accordionSectionContent = _ref2;} },

            this.props.children))));




  };return OMAccordion;}(_react.Component);exports.default = OMAccordion;


OMAccordion.propTypes = {
  titleValue: _propTypes2.default.oneOfType([_propTypes2.default.string.isRequired, _propTypes2.default.object]),
  accordionOpen: _propTypes2.default.bool,
  children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  className: _propTypes2.default.string,
  onOpen: _propTypes2.default.func,
  onClose: _propTypes2.default.func,
  afterInitialOpen: _propTypes2.default.func };


OMAccordion.defaultProps = {
  accordionOpen: false };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMAccordion/OMAccordion.js
// module id = 558
// module chunks = 0